import { render, staticRenderFns } from "./MoleculeCustomerDetail.vue?vue&type=template&id=dd889832&scoped=true&"
import script from "./MoleculeCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./MoleculeCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeCustomerDetail.vue?vue&type=style&index=0&id=dd889832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd889832",
  null
  
)

export default component.exports